// TODO: change variable name to prescriptionFormName and value to "prescriptionForm"
export var formName = "drugsForm";
export var addPatientFormName = "addPatientForm";
export var loginFormName = "loginForm";



// WEBPACK FOOTER //
// ./src/config/config.js